export const PaymentStatus = {
    PAID: 'Paid',
    UNPAID: 'Unpaid',
    PAYMENT_REQUESTED: 'Payment Requested'
}